import { render } from "./BaseQLEditor.vue?vue&type=template&id=48a90c76&scoped=true"
import script from "./BaseQLEditor.vue?vue&type=script&lang=js"
export * from "./BaseQLEditor.vue?vue&type=script&lang=js"

import "./BaseQLEditor.vue?vue&type=style&index=0&id=48a90c76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48a90c76"]])

export default __exports__